import React from 'react'
import './LanguageButton.css'

const enIcon = require('./static/en.png')
const noIcon = require('./static/no.png')
class LanguageButton extends React.Component {
  changeLanguage = () => {
    window.location.href = '/spill?la=EN'
  }

  currentLanguage = () => {
    const urlSearchParams = new URLSearchParams(window.location.search)
    const params = Object.fromEntries(urlSearchParams.entries())
    return params.la || 'NO'
  }
  render() {
    const language = this.currentLanguage()
    if (language === 'EN') return null
    return (
      <img
        className="language"
        src={language === 'NO' ? enIcon : noIcon}
        alt="language"
        onClick={this.changeLanguage}
      />
    )
  }
}

export default LanguageButton



// WEBPACK FOOTER //
// ./src/components/LanguageButton.js